import React, { useState } from "react";
import AddressField from "../../components/address/AddressField";
import VStack from "../../ui_atoms/VStack";
import { Address } from "../../components/address/address";
import type { Meta, StoryObj } from "@storybook/react";

function AddressFieldStoryComponent() {
    const [address, setAddress] = useState<Address>();
    const [address2, setAddress2] = useState<Address>();

    return (
        <VStack gap={0.5} style={{ alignSelf: "stretch" }}>
            <AddressField
                style={{ alignSelf: "stretch" }}
                value={address}
                label="Mission address"
                onSelect={setAddress}
                inputPlaceholder="Saisisez l'adresse de la mission"
                allowedCountries={["ch"]}
            />

            <AddressField
                style={{ alignSelf: "stretch" }}
                value={address2}
                label="Ajoute un lieu cool"
                onSelect={setAddress2}
                inputPlaceholder="T'habite où"
                right="add"
                allowedCountries={["ch"]}
            />
        </VStack>
    );
}

const meta = {
    title: "Fields/Address",
    component: AddressFieldStoryComponent,
    argTypes: {},
} satisfies Meta<typeof AddressFieldStoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Basic: Story = {
    args: {},
};
